export class SvrConf {
  activeProfile?: string = 'prod';
  userAgent?: string = '';
  iscrawler?: boolean = false;
  chatbotUrl?: string = '';
}

export interface IfSvrConf extends SvrConf {}
